import gql from "../gql";
import Streaks from "../fragments/Streaks";
export default gql `
  query GetLearnerStreaks(
    $first: Int
    $after: String
    $trailblazerId: TrailblazerId
  ) {
    getLearnerStreaks(
      first: $first
      after: $after
      trailblazerId: $trailblazerId
    ) {
      ...Streaks
    }
  }
  ${Streaks}
`;
